import AccidentComponent from './AccidentPage';

export default AccidentComponent;
